var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{ref:"baseImg",staticClass:"is-cover",attrs:{"src":_vm.imgSrc,"alt":_vm.alt,"rel":_vm.rel},on:{"error":function($event){$event.target.src = _vm.imgErrorSrc}}})}
var staticRenderFns = []

export { render, staticRenderFns }